<template>
  <div class="service-items">
    <el-table :data="consumptionList" tooltip-effect="light">
      <el-table-column label="项目/产品/套餐" min-width="200px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.isGift===1" effect="light" placement="bottom">
            <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
            <span class="give-icon">赠</span>
          </el-tooltip>
          <el-tooltip v-if="scope.row.isGift===2" effect="light" placement="bottom">
            <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
            <span class="buygive-icon">买赠</span>
          </el-tooltip>
          <el-tooltip v-if="scope.row.isGift===3" effect="light" placement="bottom">
            <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
            <span class="fullgive-icon">满赠</span>
          </el-tooltip>
          <span :class="scope.row.listStatus==1 ? 'project-icon' : scope.row.listStatus==2 ? 'product-icon' : 'package-icon'">{{ scope.row.listStatus==1 ? '项目' : scope.row.listStatus==2 ? '产品' : '套餐' }}</span>
          <!-- <ActivityTwo v-if="scope.row.activityType" :type="scope.row.activityType"></ActivityTwo> -->
          <span>{{ scope.row.listStatus == 1 ? scope.row.itemName : scope.row.listStatus == 2 ? scope.row.productName : scope.row.vipCardName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="原价（元）" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="折后价（元）" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.isGift===1 || scope.row.isGift===2 || scope.row.isGift===3">0.00</span>
          <span v-else>{{ (scope.row.discountMoney*1).toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="count" label="数量" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="小计（元）" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="padding-right: 5px;color: #409eff;font-weight: 600;">{{ scope.row.newPrice == 0 ? '' : scope.row.listStatus == 3 ? '' : scope.row.isGiftDeduct == 1||scope.row.isGift == 1||scope.row.isGift == 2|| scope.row.isGift == 3 ? '0.00' : ((scope.row.resultPrice*1 - (scope.row.orderItemDeduct ? (scope.row.orderItemDeduct.count*scope.row.discountMoney) : 0) - (scope.row.productDeduct ? (scope.row.productDeduct.count*scope.row.discountMoney) : 0))-scope.row.newPrice*1).toFixed(2) }}</span>

          <s v-if="scope.row.newPrice != 0 && scope.row.listStatus != 3">{{ (scope.row.resultPrice*1 - (scope.row.orderItemDeduct ? (scope.row.orderItemDeduct.count*scope.row.discountMoney) : 0) - (scope.row.productDeduct ? (scope.row.productDeduct.count*scope.row.discountMoney) : 0)).toFixed(2) || '--' }}</s>

          <span v-else>{{ scope.row.isGiftDeduct == 1||scope.row.isGift == 1||scope.row.isGift == 2||scope.row.isGift == 3 ? '0.00' : (scope.row.resultPrice*1 - (scope.row.orderItemDeduct ? (scope.row.orderItemDeduct.count*scope.row.discountMoney) : 0) - (scope.row.productDeduct ? (scope.row.productDeduct.count*scope.row.discountMoney) : 0) - (scope.row.giftItemDeduct ? (scope.row.giftItemDeduct.deductCount*scope.row.discountMoney) : 0)).toFixed(2) || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="优惠金额（元）" min-width="120px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div v-if="scope.row.isGift">--</div>
          <div v-else>
            <span>{{ scope.row.totalDiscountPrice }}</span><el-tooltip v-if="(scope.row.deductDtoList ? scope.row.deductDtoList.length > 0 ? true : false : false) || (scope.row.detailList ? scope.row.detailList.length > 0 ? true : false : false)" effect="light" placement="right">
              <div slot="content">
                <h5 v-for="(v,n) in scope.row.deductDtoList" :key="n">{{ v.isElectronicTicketDeduct == 1 ? '电子票划扣：-￥' : v.isGiftDeduct == 1 ? '赠品划扣：-￥' : '套餐划扣：-￥' }}{{ v.deductAmount }}</h5>
                <h5 v-for="(v,n) in scope.row.detailList" v-show="v.type != 1 && v.type != 99" :key="n">{{ v.type == 2 ? '特价活动：-￥' : v.type == 3 ? '定时打折：-￥' : v.type == 4 ? '会员优惠：-￥' : v.type == 5 ? '改价优惠：-￥' : '' }}{{ ((scope.row.price*1-v.rightsPrice*1)*v.count).toFixed(2) }}</h5>
              </div>
              <i class="iconfont" style="font-size: 14px;color:#d3d3d3;margin-left: 5px;">&#xe71a;</i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提成员工">
        <template slot-scope="scope">
          <div v-if="scope.row.listStatus == 1">
            <el-tooltip v-if="scope.row.percentage4ServeList.length > 0" class="item" effect="light" placement="right-start">
              <div slot="content" style="display: flex;">
                <p>{{ Lib.collectively() }}：</p>
                <div style="flex: 1;">
                  <p v-for="(item,index) in scope.row.percentage4ServeList" :key="index" style="padding: 0 10px 0 0;">
                    <span>{{ item.isGuest == 1 ?'点客':'非点客' }}-{{ item.technicianName }}<br></span>
                    <!-- <span>{{item.technicianName}}({{ item.item4ServeList[0].price }}{{item.item4ServeList[0].percentageType == 1 ? '元' : '%'}})<br></span> -->
                  </p>
                </div>
              </div>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span>{{ Lib.collectively() }}：</span>
                <span v-for="(a,b) in scope.row.percentage4ServeList" :key="b">{{ a.isGuest == 1 ?'点客':'非点客' }}-{{ a.technicianName }}{{ scope.row.percentage4ServeList.length == (b+1) ? '' : ',' }}</span>
              </p>
            </el-tooltip>
            <span v-if="scope.row.percentage4ServeList.length == 0 && scope.row.percentageSellServeList.length == 0">--</span>
            <el-tooltip v-if="scope.row.percentageSellServeList.length > 0" class="item" effect="light" placement="right-start">
              <div slot="content" style="display: flex;">
                <p>销售：</p>
                <div style="flex: 1;">
                  <p v-for="(item,index) in scope.row.percentageSellServeList" :key="index" style="padding: 0 10px 0 0;">
                    <span>{{ item.technicianName }}<br></span>
                  </p>
                </div>
              </div>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span>销售：</span>
                <span v-for="(c,d) in scope.row.percentageSellServeList" :key="d">{{ c.technicianName }}{{ scope.row.percentageSellServeList.length == (d+1) ? '' : ',' }}</span>
              </p>
            </el-tooltip>
          </div>
          <div v-if="scope.row.listStatus == 2">
            <el-tooltip v-if="scope.row.percentage4ProductList.length > 0" class="item" effect="light" placement="right-start">
              <div slot="content" style="display: flex;">
                <p>销售：</p>
                <div style="flex: 1;">
                  <p v-for="(item,index) in scope.row.percentage4ProductList" :key="index" style="padding: 0 10px 0 0;">
                    <span>{{ item.technicianName }}<br></span>
                  </p>
                </div>
              </div>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span>销售：</span>
                <span v-for="(c,d) in scope.row.percentage4ProductList" :key="d">{{ c.technicianName }}{{ scope.row.percentage4ProductList.length == (d+1) ? '' : ',' }}</span>
              </p>
            </el-tooltip>
            <span v-else>--</span>
          </div>
          <div v-if="scope.row.listStatus == 3">
            <el-tooltip v-if="scope.row.percentage4PackageList.length > 0" class="item" effect="light" placement="right-start">
              <div slot="content" style="display: flex;">
                <p>销售：</p>
                <div style="flex: 1;">
                  <p v-for="(item,index) in scope.row.percentage4PackageList" :key="index" style="padding: 0 10px 0 0;">
                    <span>{{ item.technicianName }}<br></span>
                  </p>
                </div>
              </div>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span>销售：</span>
                <span v-for="(c,d) in scope.row.percentage4PackageList" :key="d">{{ c.technicianName }}{{ scope.row.percentage4PackageList.length == (d+1) ? '' : ',' }}</span>
              </p>
            </el-tooltip>
            <span v-else>--</span>
          </div>
        </template>
        <!-- <template slot-scope="scope">
                    <span v-if="scope.row.listStatus == 1">{{scope.row.technicianName || '--'}}</span>
                    <div v-else-if="scope.row.listStatus == 2">
                        <span v-for="(v,n) in scope.row.percentage4ProductList" :key="n">{{v.technicianName}}{{scope.row.percentage4ProductList.length == (n+1) ? '' : ','}}</span>
                    </div>
                    <div v-else-if="scope.row.listStatus == 3">
                        <span v-for="(v,n) in scope.row.percentage4PackageList" :key="n">{{v.technicianName}}{{scope.row.percentage4PackageList.length == (n+1) ? '' : ','}}</span>
                    </div>
                </template> -->
      </el-table-column>
    </el-table>
    <div class="margin-top-20">
      订单合计：
      <span class="themeFC" v-text="'¥  '+(serviceItems.itemsSumTotal*1+productSales.productsSumTotal*1+vipCard.packageSumTotal*1).toFixed(2)"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    serviceItems: {
      type: Object,
      default() {
        return {
          serveItemsList: [],
          itemsSumTotal: ''
        };
      }
    },
    productSales: {
      type: Object,
      default() {
        return {
          productSalesList: [],
          productsSumTotal: ''
        };
      }
    },
    vipCard: {
      type: Object,
      default() {
        return {
          vipCardList: [],
          packageSumTotal: ''
        };
      }
    },
    consumptionList: {
      type: Array,
      default: Array
    },
  }
};
</script>

<!-- 消费清单-->
<style lang="less" scoped>
.service-items {
  font-size: 14px;
  padding: 10px 30px 0 30px;
}
.margin-top-20 {
  margin-top: 20px;
}
</style>
